module.exports = __webpack_public_path__ + "img/equipment-item.42194058.svg";